module.exports = __webpack_public_path__ + "static/media/brand-kit-mobile@3x.5699c991.png";